import React from 'react';
import { Box, Typography, Fab, TextField } from '@mui/material';
import {
  CloudUploadRounded,
  CheckCircleOutlineRounded,
} from '@mui/icons-material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { MobileDateTimePicker } from '@mui/x-date-pickers';
import BootstrapTooltip from './VideoUploadStyled';

const FileUploadSection = ({
  isLoading,
  handleFileChange,
  uploadedFile,
  customFileName,
  handleCustomFileNameChange,
  date,
  dateChangeHandler,
}) => (
  <>
    <Typography
      sx={{
        color: '#9291F0',
        fontFamily: 'Karla',
        fontWeight: 750,
        fontSize: '24px',
        // borderBottom: '3px solid #9291F0',
      }}
    />
    {/* <Typography gutterBottom sx={{ textAlign: 'center', mt: '0.3rem' }}>
      Upload video for review
    </Typography> */}
    <Box className='flexBox flexCenter'>
      <BootstrapTooltip title='choose a file' placement='right'>
        <Fab
          variant='extended'
          component='label'
          color='secondary'
          size='small'
        >
          <CloudUploadRounded />
          <input
            hidden
            accept='video/*'
            multiple
            type='file'
            onChange={handleFileChange}
            disabled={isLoading}
          />
        </Fab>
      </BootstrapTooltip>
    </Box>
    <Typography className='flexBox flexCenter' color={'GrayText'}>
      {uploadedFile?.name && (
        <>
          {customFileName
            ? customFileName.charAt(0).toUpperCase() + customFileName.slice(1)
            : uploadedFile?.name}
          {uploadedFile?.name && <CheckCircleOutlineRounded color='success' />}
        </>
      )}
    </Typography>
    <Typography
      gutterBottom
      className='dateInput'
      style={{ marginBottom: '8px' }}
    >
      * File Name
    </Typography>
    <TextField
      variant='outlined'
      label='Custom File Name'
      value={customFileName}
      onChange={handleCustomFileNameChange}
      disabled={isLoading}
      className='fullWidth'
    />
    <Typography gutterBottom className='dateInput'>
      * Date of video taken
    </Typography>
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <MobileDateTimePicker
        label='Date Of Video Taken'
        disableFuture
        className='fullWidth'
        value={date || null}
        disabled={isLoading}
        onChange={dateChangeHandler}
        renderInput={(params) => <TextField {...params} />}
      />
    </LocalizationProvider>
  </>
);

export default FileUploadSection;
